export default function Placeholder({ label = "LOGO", className = "", minH = "min-h-[160px]" }) {
  return (
    <div
      className={`w-full ${minH} bg-[#141414] border border-white/10 rounded-xl flex items-center justify-center overflow-hidden relative ${className}`}
      data-testid="placeholder"
    >
      <div className="absolute inset-0 nh-grid-bg opacity-40" />
      <span className="relative font-mono text-xs tracking-[0.3em] uppercase text-white/40">
        {label}
      </span>
    </div>
  );
}
